export interface RoomDistributionData {
  room_count: number
  unit_count: number
}

export interface UnitTypeData {
  unit_type: string
  unit_count: number
  avg_area: number
}

export interface UnitCompositionChartLabels {
  roomDistribution?: string
  roomDistributionSubtext?: string
  room?: string
  rooms?: string
  numberOfUnits?: string
  numberOfRooms?: string
  unitTypeComposition?: string
  unitTypeCompositionSubtext?: string
  averageArea?: string
  units?: string
  noData?: string
}

export const DEFAULT_UNIT_COMPOSITION_CHART_LABELS: UnitCompositionChartLabels =
  {
    roomDistribution: 'Room Distribution',
    roomDistributionSubtext: 'Number of Units by Room Count',
    room: 'Room',
    rooms: 'Rooms',
    numberOfUnits: 'Number of Units',
    numberOfRooms: 'Number of Rooms',
    unitTypeComposition: 'Unit Type Composition',
    unitTypeCompositionSubtext:
      'Size represents unit count, color represents average area',
    averageArea: 'Average Area',
    units: 'units',
    noData: 'No unit composition data available',
  }

export interface UnitCompositionChartProps {
  roomDistributionData?: RoomDistributionData[]
  unitTypeData?: UnitTypeData[]
  loading?: boolean
  error?: string | null
  height?: number
  labels?: Partial<UnitCompositionChartLabels>
}
